import { render, staticRenderFns } from "./customerGrade.vue?vue&type=template&id=33336a12&scoped=true"
import script from "./customerGrade.vue?vue&type=script&lang=js"
export * from "./customerGrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33336a12",
  null
  
)

export default component.exports